<template>
  <base-nav class="navbar-top navbar-dark"  id="navbar-main" :show-toggle-button="false" expand>
    <router-link class="navbar-brand" :to="isShippop()">
      <img src="/img/brand/logo.png" class="navbar-brand-img max-navbar-logo" />
      <span class="small mb-0 ml-1 align-bottom version-text">V {{popVersion}}</span>
    </router-link>
    <!-- IT-3404 — ประกาศข่าวสาร (desktop); below md the entry is in the sidebar (DashboardLayout) -->
    <router-link
      v-if="showAnnouncement"
      to="/announcements"
      class="pop-ann-link d-none d-md-inline-flex"
      :style="{ '--ann-accent': $THEME.primaryColor || '#11cdef' }"
    >
      <i class="fas fa-bullhorn" aria-hidden="true"></i>
      <span>ประกาศข่าวสาร</span>
      <span v-if="annState.unread" class="pop-ann-count" :aria-label="'ยังไม่ได้อ่าน ' + annState.unread + ' รายการ'">{{ annState.unread > 99 ? '99+' : annState.unread }}</span>
    </router-link>
    <ul class="navbar-nav align-items-center d-none d-md-flex justify-content-end w-100">
      <DropDownWallet v-if="$WALLET.status == true"/>
      <div class="left-divider-wrapper ml-3" v-if="allowCoupon">
        <DropDownCoupon />
      </div>
      <div class="pl-4 pr-2">
        <NotificationBell :dataNotify="dataNotify" :paginate="paginate" :isload="isload" :newMessage="newMessage"
        :setNewMessage="setNewMessage"/>
      </div>
      <!-- <div class="pl-4 pr-2">
        <i class="fas fa-th"></i>
      </div> -->
      <li class="nav-item dropdown">
        <DropDownShop />
      </li>
    </ul>

    <VerifyWalletModal ref="verifyWalletModal" />
  </base-nav>
</template>
<script>
import { getCookie } from "@/helpers/util"
import NotificationBell from "@/components/NotificationPlugin/NotificationBell"
import DropDownShop from "@/components/custom/DropDownShop"
import DropDownWallet from "@/components/custom/DropDownWallet"
import VerifyWalletModal from '@/components/Wallet/VerifyWalletModal'
import DropDownCoupon from "@/components/custom/DropDownCoupon.vue"
import { ANNOUNCEMENT_POSITION, announcementState, refreshUnread } from "@/axios/announcement.js"

export default {
  components:{
    NotificationBell,
    DropDownShop,
    DropDownWallet,
    VerifyWalletModal,
    DropDownCoupon
  },
  data() {
    return {
      popVersion: process.env.VUE_APP_VERSION,
      activeNotifications: false,
      newMessage: false,
      showMenu: false,
      dataNotify:[],
      isload: false,
      paginate:{
        page: 1,
        totalPage: 0,
      },
      searchQuery: "",
      userLogin: "",
      allowCoupon: false,
      annState: announcementState,
    };
  },
  computed: {
    // same audience as the POS page (router: /pos and /announcements are member + admin)
    showAnnouncement() {
      return !!ANNOUNCEMENT_POSITION && !!this.userLogin && ['member', 'admin'].includes(this.userLogin.role)
    },
  },
  mounted(){
    this.userLogin = JSON.parse(localStorage.getItem('user'))
    this.getNotify()
    if (this.showAnnouncement) refreshUnread()

    this.$refs.verifyWalletModal.openModal()
  },
  created() {
    if (
      this.main_use_walletV2 && 
      this.main_allow_coupon && 
      [
        this.$USER_LOGIN.get().isAdmin,
        this.$USER_LOGIN.get().isMember
      ].includes(true)) {
        this.allowCoupon = true
    }
  },
  methods: {
    setNewMessage( status ){
      this.newMessage = status
    },
    async getNotify(){
      this.isload = true
      await this.$http.get( this.$API_URL + '/notify', {
        headers : {
           Token: localStorage.getItem("access_token")
        },
        params: {
          page: this.paginate.page
        }
      }).then( res => {

        let data = res.data.data
        this.dataNotify = [ ...this.dataNotify , ...data.data]

        if( this.dataNotify.length && 
          ( 
            !getCookie('read_noti') || 
            (this.moment(this.dataNotify[0].created_at).valueOf() > getCookie('read_noti'))
          )
        ){

          this.setNewMessage( true )

        }else{

          this.setNewMessage( false )

        }
        this.paginate.page = data.page
        this.paginate.totalPage = data.total_page

      })
      this.isload = false

    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    isShippop(){
      let part = '/'
      if( this.userLogin.role === 'shippop' ){
        part = ''
      }
      return part
    }
  },
  watch: {
    '$route' (to, from) {
      if(from.name == 'usershop'){
        this.userLogin = JSON.parse(localStorage.getItem('user'))
      }

      this.$refs.verifyWalletModal.openModal()
    },
    'paginate.page' ( old , current ){
      this.getNotify()
    }
  },
};
</script>
<style lang="scss" scoped>

    #navbar-main{

      z-index: 101;
      
    }
    .word-break {
      white-space: normal;
      word-break: break-word;
    }
    #new-message{

      font-size: 10px;

    }
  .notify-admin{

    #btn-notify{

      color:whitesmoke;
    }

    &:hover{
      cursor: pointer
    }
    #btn-notify:active{
      color:#f5f5f59c;
    }
  }
  .version-text {
    font-size: 1rem;
  }
  /* IT-3404 — ประกาศข่าวสาร link + unread count */
  .pop-ann-link {
    align-self: stretch; /* full navbar height, so the active underline sits on the navbar's bottom edge */
    align-items: center;
    gap: 8px;
    margin-left: 24px;
    padding: 3px 2px 0; /* top 3px balances the 3px bottom border: text stays centred */
    border-bottom: 3px solid transparent;
    color: #525f7f;
    font-size: 0.9375rem;
    font-weight: 500;
    white-space: nowrap;
    text-decoration: none;
    transition: border-color .18s ease, color .18s ease;
    &:hover, &:focus, &.router-link-active { color: #32325d; border-bottom-color: var(--ann-accent); }
    &:focus-visible { outline: 2px solid #0773a0; outline-offset: 2px; }
  }
  .pop-ann-count {
    display: inline-block;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    background: #e5483f;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
    font-variant-numeric: tabular-nums;
  }
  @media (prefers-reduced-motion: reduce) { .pop-ann-link { transition: none; } }
</style>
<style lang="scss">
/* IT-3404 — let the collapse (which holds ประกาศข่าวสาร) fill the navbar height; the right-hand
   items keep their vertical centring (their ul has .align-items-center) */
#navbar-main .navbar-collapse {
  align-self: stretch;
}
</style>
